import environment from '../environment';
import StoresControl from './StoresControl';

export class DealershipsControl extends StoresControl {
    constructor () {
        const options = {
            name: 'Dealerships',
            context: 'LAYER_NETWORK',
            stores: environment.get('CONFIG.DEALERS')
        };

        super(options);
    }

    static getInstance () {
        if (!DealershipsControl._instance) {
            DealershipsControl._instance = new DealershipsControl();
        }

        return DealershipsControl._instance;
    }
}

export default DealershipsControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/DealershipsControl.js